import { render, staticRenderFns } from "./VariableScopeBadge.vue?vue&type=template&id=71ea556c&"
import script from "./VariableScopeBadge.vue?vue&type=script&lang=js&"
export * from "./VariableScopeBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports